/**
 * "Sep 8, 2026" for an event's creation date, in the viewer's own language and calendar.
 * `null` when the date is missing or unreadable, so a caller can simply show nothing rather than
 * "Invalid Date".
 */
export function formatCreated(iso: string | null | undefined, locale?: string): string | null {
  if (!iso) return null;
  const time = Date.parse(iso);
  if (!Number.isFinite(time)) return null;
  return new Date(time).toLocaleDateString(locale, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

/** The full date and time, for a tooltip: "Tuesday, September 8, 2026 at 3:45 PM". */
export function formatCreatedLong(iso: string | null | undefined, locale?: string): string | null {
  if (!iso) return null;
  const time = Date.parse(iso);
  if (!Number.isFinite(time)) return null;
  return new Date(time).toLocaleString(locale, {
    dateStyle: "full",
    timeStyle: "short",
  });
}
